import React from 'react'

const renderError = error => <div key={error} className='error u-text--center'>{error}</div>

export const BaseField = ({ formGroupClassName, label, labelClassName, disabled, disabledReason, meta: { touched, error }, children, input } ) => {
	return <div className={formGroupClassName} {... disabled ? { title: disabledReason } : {}} >
		{ label && <label htmlFor={input.name} className={`c-label ${labelClassName}`}>{label}</label>}
		{children}
		{ touched && error && <div className='u-text--monza c-error'>{Array.isArray(error) ? error.map(renderError) : renderError(error)}</div> }
	</div>
}

export default BaseField